export default __webpack_public_path__ + "assets/images/2ec73007d59e23c88ff970f8317bb895.svg";